<template>
    <div class="outlet-search-container">
        <div v-show="showPage">
            <header>
                <img class="banner" @click="toDetail" src="@/assets/banner.webp">
                <div class="title">
                    <span class="active">国补网点查询</span>
                </div>
                <div class="select">
                    <!-- <select class="form-control selectBox" id="province"></select> -->
                    <select class="form-control selectBox" id="province" v-model="provinceId">
                        <option
                        v-for="(item, index) in provinceLists"
                        :key="index"
                        :value="item.provinceId">{{ item.name }}</option>
                    </select>
                    <!-- <select class="form-control selectBox" id="city"></select> -->
                    <select class="form-control selectBox" id="city" v-model="cityId">
                        <option
                        v-for="(item, index) in cityLists"
                        :key="index"
                        :value="item.cityId">{{ item.name }}</option>
                    </select>
                    <!-- <select class="form-control selectBox" id="town"></select> -->
                    <select class="form-control selectBox" id="town" v-model="countyId">
                        <option
                        v-for="(item, index) in countyLists"
                        :key="index"
                        :value="item.districtId">{{ item.name }}</option>
                    </select>
                </div>
            </header>
            <main>
                <div class="address">
                    <ul id="wd">
                        <template v-if="!outletLists.length && provinceId > 0">
                            <p class="no_result">暂无附近网点哦~</p>
                        </template>
                        <template v-else>
                            <li @click="initializeMap(item)" v-for="item in outletLists" :key="item.orgId">
                                <p class="address1">{{ item.outletName }}</p>
                                <p class="address2">地址：{{ item.address }}</p>
                                <div>
                                    <div @click.stop="call" class="address2">
                                        电话：<a :href="`tel:${item.contact}`" style="text-decoration:none;margin-right:14px;" class="address2">{{ item.contact }}</a>
                                    </div>
                                    <div class="contact" @click.stop="showDialog(item.contractUserId)">在线联系</div>
                                </div>
                                <p class="distance" v-if="item.tmpDistance">{{ item.tmpDistance }}</p>
                            </li>
                        </template>
                    </ul>

                </div>

            </main>
        </div>
        <div class="send">
            <a href="https://services.youxuepai.com/branches/mobile/">
                <img src="@/assets/send_cargo.png" width='59'>
                <!-- <span>全部网点</span> -->
            </a>
        </div>
        <div class="tel" v-show="showPage">
            <a href="tel:4006289898">
                <img src="@/assets/kefu.png" width='59'>
                <!-- <span>客服热线</span> -->
            </a>
        </div>
        <div v-show="!showPage">
            <div class='detail-title'>
                <a @click="showPage = true;" class="returns back">
                    <img src="@/assets/button_page.png">
                </a>
                <p class="middle_span">国补网点查询</p>
                <p class='address-name'>{{ addressName }}</p>
            </div>
            <div class="mapContent">  
                <div id="map" style="width: 100%;height: 400px"></div>
            </div>
            <div class="resultContent">
                <ul>
                    <li data-name="r-result" @click="resultType = 1" :class="{'active': resultType === 1}" style='border-width: 0'>

                        <!--					<p>公交<img src="images/pre_bus.png" alt="" style="width: 1.3em;left: 32%;top: 35%;"></p>-->
                        <p>公交</p>
                        <!--					<div class="line"></div>-->
                    </li>
                    <li data-name="r-result2" @click="resultType = 2" :class="{'active': resultType === 2}" style='border-width: 0'>
                        <!--					<img src="images/nor_car.png" alt="" style="width: 1.5em;left: 24%;top: 34%;">-->
                        <p>驾车</p>
                        <!--					<div class="line"></div>-->
                    </li>
                    <li data-name="r-result3" @click="resultType = 3" :class="{'active': resultType === 3}" style="width: 33.4%;border-width: 0">
                        <!--					<img src="images/nor_walk.png" alt="" style="width: 0.8em;left: 30%;top: 33%;">-->
                        <p>步行</p>
                    </li>
                </ul>
                <div class="resultContentBlock">
                    <div id="r-result" v-show="resultType === 1" style="width: 100%;height:auto;"></div>
                    <div id="r-result2" v-show="resultType === 2" style="width: 100%;height: auto;"></div>
                    <div id="r-result3" v-show="resultType === 3" style="width: 100%;height: auto;"></div>
                </div>
            </div>
        </div>
        <div class="coverMask" v-show="showCoverMask">
            <div class="popUp">
                <div class="popUp-close" @click="showCoverMask=false">
                    <img  class="popUp-close-icon" src="@/assets/close.png">
                </div>
                <div class="popUp-title">
                    服务导购
                </div>
                <div class="popUp-img">
                    <img id="codeImg" :src="codeImg">
                </div>
                <div class="popUp-text">
                    长按识别二维码，添加导购进行咨询
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from './api.js';
export default {
    name: 'OutletSearch',
    data () {
        return {
            proName: '北京', // 省名称
            cityName: '北京市', // 市名称
            currentLng: 116.40, // 当前位置的经度
	        currentLat: 39.91, // 当前位置的纬度
            provinceId: -1, // 省Id
            cityId: -1, // 市Id
            countyId: -1, // 区县Id
            provinceLists: [], // 省列表
            cityLists: [], // 市列表
            countyLists: [], // 区县列表
            outletLists: [], // 网点列表
            geoc: {},
            geolocation: {},
            timer: null,
            showPage: true, // 显示主页
            addressName: '',
            showCoverMask: false, // 显示联系导购弹窗
            codeImg: '', // 服务导购二维码
            resultType: 1, // 1:公交 2:驾车 3：步行
        };
    },
    watch: {
        provinceId (val) {
            this.getCityLists();
            this.getNationalSubsidyOutlets();
        },
        cityId () {
            this.getDistrictLists();
            this.getNationalSubsidyOutlets();
        },
        countyId () {
            this.getNationalSubsidyOutlets();
        },
    },
    computed: {
    },
    components: {
    },
    created () {
    },
    mounted () {
        this.init();
    },
    methods: {
        init () {
            this.geoc = new BMap.Geocoder();
            this.geolocation = new BMap.Geolocation();
            const _this = this;
            this.geolocation.getCurrentPosition(function(r) {
                if(this.getStatus() == BMAP_STATUS_SUCCESS) {
                    _this.setLocation(r.point);
                } else {
                    _this.currentLng = 116.40; //获取到当前位置的经纬度
                    _this.currentLat = 39.91;
                    _this.proName = "北京";
                    _this.cityName = "北京市";
                    _this.getProvinceLists();
                }
            }, {
                enableHighAccuracy: true
            });
        },
        //获取地理位置的函数
		setLocation(point) {
            const _this = this;
			this.geoc.getLocation(point, function(rs) {
				_this.currentLng = rs.point.lng; //获取到当前位置的经纬度
				_this.currentLat = rs.point.lat;
				var addComp = rs.addressComponents;
				_this.proName = addComp.province;
				_this.cityName = addComp.city;
				//console.log("当前的位置为:"+proName+","+cityName);
				_this.getProvinceLists();
				//$("#province").change();

			});
		},
        // 获取省列表
        getProvinceLists () {
            api.getProvinceLists({ countryId: 156, bindAgent: 0 }).then(res => {
                if (res.errcode === 0) {
                    const list = res.data.list;
                    list.unshift({
                        provinceId: -1,
                        name: '--省份--',
                    });
                    const data = list.find(item => this.proName.includes(item.name));
                    if (data) {
                        this.provinceId = data.provinceId;
                    }
                    this.provinceLists = list;
                } else {
                    this.$toast(res.errmsg);
                }
            }).catch(err => {
                
            });
        },
        // 获取市列表
        getCityLists () {
            if (!(this.provinceId && this.provinceId > 0)) {
                this.cityId = -1;
                this.cityLists = [];
                return;
            }
            const params = {
                provinceId: this.provinceId,
                userId: 43917,
                bindAgent: 0,
            };
            api.getCityLists(params).then(res => {
                if (res.errcode === 0) {
                    const list = res.data.list;
                    list.unshift({
                        cityId: -1,
                        name: '--市区--',
                    });
                    this.cityId = list[1] ? list[1].cityId : -1;
                    this.cityLists = list;
                } else {
                    this.$toast(res.errmsg);
                }
            }).catch(err => {
                
            });
        },
        // 获取区县列表
        getDistrictLists () {
            this.countyId = -1;
            const params = {
                cityId: this.cityId,
                bindAgent: 0,
            };
            api.getDistrictLists(params).then(res => {
                if (res.errcode === 0) {
                    res.data.list.unshift({
                        districtId: -1,
                        name: '--区县--',
                    });
                    this.countyLists = res.data.list;
                } else {
                    this.$toast(res.errmsg);
                }
            }).catch(err => {
                
            });
        },
        // 获取网点列表
        getNationalSubsidyOutlets () {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.outletLists = [];
                const params = {
                    countryId: 156,
                    provinceId: this.provinceId,
                };
                if (this.cityId && this.cityId > 0) {
                    Object.assign(params, {
                        cityId: this.cityId,
                    });
                }
                if (this.countyId && this.countyId > 0) {
                    Object.assign(params, {
                        districtId: this.countyId,
                    });
                }
                api.getNationalSubsidyOutlets(params).then(res => {
                    if (res.errcode === 0) {
                        var result = res.data.list;
                        function compare(value1, value2) {
                            if(value1.distance < value2.distance) {
                                return 1;
                            } else if(value1.distance > value2.distance) {
                                return -1;
                            } else {
                                return 0;
                            }
                        }
                        //成功执行处理
                        for(var i = 0; i < result.length; i++) {
                            var contact = result[i].contractPhone ? result[i].contractPhone : result[i].contractTel;
                            result[i].contact = contact;
                            
                            if (this.filterShop(result[i].orgId)){
                                continue;
                            }
                            var pointA = new BMap.Point(this.currentLng, this.currentLat); // 创建点坐标A--定位的位置
                            var pointB = new BMap.Point(result[i].longitude, result[i].latitude); // 创建点坐标B--当前网点位置
                            var map = new BMap.Map("map");
                            var distance = (map.getDistance(pointA, pointB)).toFixed(2);
                            //console.log(''+distance+' 米。');  //获取两点距离,保留小数点后两位
                            if (distance && !isNaN(distance)) {
                                var tmpDistance = Number(distance);
                                if (tmpDistance >= 1000) {
                                    if (tmpDistance >= 100000) {
                                        tmpDistance = Number((tmpDistance / 1000).toFixed(0)) + 'km';
                                    } else {
                                        tmpDistance = Number((tmpDistance / 1000).toFixed(1)) + 'km';
                                    }
                                } else {
                                    tmpDistance = Number(tmpDistance.toFixed(1)) + 'm';
                                }
                                result[i].tmpDistance = tmpDistance;
                            }
                            result[i].distance = distance;
                            // arrayResult.push(result[i]);
                        }
                        result.sort(this.sortNetworks);
                        this.outletLists = result;
                    } else {
                        this.$toast(res.errmsg);
                    }
                }).catch(err => {
                    
                });
            }, 1000);
            
        },
        sortNetworks(value1, value2) {
            if(parseFloat(value1.distance) < parseFloat(value2.distance)) {
                return -1;
            } else if(parseFloat(value1.distance) > parseFloat(value2.distance)) {
                return 1;
            } else {
                return 0;
            }
        },
        // banner详情
        toDetail () {
            // window.open('https://baidu.com');
        },
        filterShop (id) {
            var filterList = ['7363', '9953', '11245', '11247', '11248'];
            if (filterList.indexOf(id + '') != -1) {
                return true;
            }
            return false;
        },
        // 获取选择网点的经纬度
        initializeMap(o) {
            this.resultType = 1;
            this.showPage = false;
            this.initialize(o.longitude, o.latitude); //调用initialize事件
            this.addressName = o.outletName;
        },
        // 地图功能
	    initialize(lo, la) { //参数来自于initializeMap
                //创建对象
                var geolocation = new BMap.Geolocation();
                var nowLng;
                var nowLat;
                //使用浏览器定位当前经纬度
                geolocation.getCurrentPosition(function(r) {
                    if(this.getStatus() == BMAP_STATUS_SUCCESS) {
                        nowLng = r.point.lng; //获取到当前位置的经纬度
                        nowLat = r.point.lat;
                        //                    setLocation(r.point);
                        // 百度地图API功能
                        var map = new BMap.Map("map"); // 创建Map实例
                        map.centerAndZoom(new BMap.Point(nowLng, nowLat), 12); //地图初始化
                        var p1 = new BMap.Point(lo, la);
                        var p2 = new BMap.Point(nowLng, nowLat);
                        var opts = {
                            type: BMAP_NAVIGATION_CONTROL_SMALL
                        }; //放大缩小
                        //公交路线
                        var transit = new BMap.TransitRoute(map, {
                            renderOptions: {
                                map: map,
                                panel: "r-result"
                            }
                        });
                        transit.search(p2, p1);
                        //驾车路线
                        var driving = new BMap.DrivingRoute(map, {
                            renderOptions: {
                                map: map,
                                panel: "r-result2",
                                autoViewport: true
                            }
                        });
                        driving.search(p2, p1);
                        //步行路线
                        var walking = new BMap.WalkingRoute(map, {
                            renderOptions: {
                                map: map,
                                panel: "r-result3",
                                autoViewport: true
                            }
                        });
                        walking.search(p2, p1);
                        //可缩放功能
                        map.addControl(new BMap.NavigationControl(opts));
                    } else {
                        alert('failed' + this.getStatus());
                    }
                }, {
                    enableHighAccuracy: true
                });
            },
        call(){},
        showDialog (contractUserId) {
            this.codeImg = '';
            const params = {
                yxpUserId: contractUserId,
            };
            api.getWechatQrCode(params).then(res => {
                if (res.errcode === 0) {
                    this.codeImg = res.data;
                    this.showCoverMask = true;
                    let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
                    document.body.style.cssText += 'position:fixed;width:100%;top:-' + scrollTop + 'px;';
                } else {
                    this.$toast(res.errmsg);
                }
            }).catch(err => {
            });
        },
    },
}
</script>
<style lang="scss" scoped>
    .outlet-search-container {
        max-width: 500px;
        margin: 0 auto;
        .banner {
            width: 100%;
            cursor: pointer;
        }
        header .title{
            width: 100%;
            overflow: hidden;
            text-align: center;
        }
        header .title img{
            width: 0.7em;
            position: absolute;
            top: 11%;
            left: 5%;
            display: none;
        }
        main{
            margin-bottom: 28px;
            width: calc(100% - 10px);
            overflow-y: auto;
        }
        header span{
            display: inline-block;
            padding-top: 3%;
            padding-bottom: 3%;
            font-size: 18px;
            width: 50%;
            text-align: center;
            // float: left;
        }
        header span.active{
            border-bottom: 3px solid #f7be09;
        }
        .detail-title {
            position: fixed;
            height: 90px;
            width: 100%;
            max-width: 500px;
            top: 0;
            // box-shadow: 4px 0px 4px #aaa;
            background: rgb(254, 254, 254);
            z-index: 999;
        }
        .detail-title .returns img{
            width: 26px;
            position: absolute;
            top: 6px;
            left: 20px;
            padding: 6px;
        }
        .detail-title .middle_span {
            text-align: center;
            padding: 3% 0;
            font-size: 18px;
        }
        .address-name {
            position: absolute;
            font-size: 16px;
            bottom: 0px;
            width: 90%;
            left: 24px;
            bottom: 10px;
            color: #666666;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            /*width: 79%;*/
            margin: 0;
            padding-left: 28px;
            background: url('~@/assets/icon.png') no-repeat center left;
            background-size:18px 18px;
            line-height: 21px;
            background-position-y: 40%;
        }
        .form-control {
            display: block;
            width: 100%;
            height: 34px;
            padding: 6px 12px;
            font-size: 14px;
            line-height: 1.42857143;
            color: #555;
            background-color: #fff;
            background-image: none;
            border: 1px solid #ccc;
            border-radius: 4px;
            -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
            box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
            -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
            -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
            transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
        }
        header .select{
            margin-top: 14px;
        }
        .select .selectBox{
            width: calc(100% - 60px);
            border-radius: 20px;
            height: 40px;
            margin: 8px auto;
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            background: url('~@/assets/icon_1.png') 96% / 20% no-repeat;
            background-size: 12px;
        }
        header .select:after{
            content: "";
            pointer-events: none;
            position: absolute;
            right: 1px;
            top: 1%;
            z-index: 99999;
        }
        main .address{
            width: 100%;
            height: auto;
            overflow: auto;
            overflow-x: hidden;
        }
        main .address ul{
            width: 100%;
            margin-top: 10px;
            margin-bottom: 20px;
        }
        #wd p.no_result{
            // position: absolute;
            // top: 62%;
            // left: 33%;
            color: #666;
            text-align: center;
        }
        main .address ul li{
            width: calc(92% - 36px);
            padding: 10px 20px;
            background-color: #ffffff;
            list-style: none;
            border-bottom: 1px solid #eee;
            border-top-left-radius: 0.5em;
            border-top-right-radius: 0.5em;
            margin: 0 auto;
            position: relative;
            box-sizing: content-box;
        }

        .address1{
            font-size: 16px;
            font-weight: 500;
            line-height: 28px;
            color: #666666;
            padding-left: 24px;
            background: url('~@/assets/icon.png') no-repeat center left;
            background-size:16px 16px;
            background-position-y: 40%;
            width: calc(100% - 90px);
        }
        .address2{
            font-size: 13px;
            font-weight: 500;
            line-height: 20px;
            color: #999;
            overflow: hidden;
            /* width: 100%; */
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .contact{
            margin-top: 4px;
            font-size: 13px;
            font-weight: 500;
            line-height: 30px;
            border-radius: 20px;
            color: #312f2a;
            background-color:#ffebb9;
            width: 80px;
            text-align: center;
            overflow: hidden;
            /* width: 100%; */
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .phone{
            color: #999;
            font-size: 13px;
            font-family: Arial;
            margin-top: 2px;
        }
        .distance{
            font-size: 16px;
            line-height: 28px;
            color: #666666;
            right: 18px;
            top: 10px;
            position: absolute;
        }
        .tel{
            position: fixed;
            bottom: 20px;
            right: 20px;
            z-index: 9;
        }
        .send{
            position: fixed;
            bottom: 95px;
            right: 20px;
            z-index: 9;
            
        }
        .send, .tel {
            a {
                position: relative;
                span {
                    color: #626262;
                    font-size: 11px;
                    position: absolute;
                    bottom: 10px;
                    left: 8px;
                    font-weight: 700;
                }
            }
        }
        .bottom a{
            width: 100%;
            display: block;
        }
        .bottom img{
            margin-top: 14px;
            width: 38%;
            margin-left: 32%;
        }
        .mapContent{
            width: 100%;
            margin-top: 90px;
            border-bottom: 1px solid #DDDDDD;
            z-index: 0;
        }

        .resultContent{
            width: 100%;
            /*margin-top: 10px;*/
        }
        .resultContent ul{
            padding: 0;
            margin: 0;
            /*background: #f7f7f7;*/
        }
        .resultContent ul li{
            width: 33.3333%;
            display: inline-block;
            font-size: 15px;
            /*font-weight: 500;*/
            line-height: 34px;
            color: #333333;
            text-align: center;
            margin-right: -4px;
            /*margin-top: 2px;*/
            /*position: relative;*/
        }
        .resultContent ul li p{
            /*padding-left: 10%;*/
        }
        .resultContent ul li img{
            position: absolute;
            top: 20%;
            left: 15%;
            vertical-align: middle;
        }
        .resultContent ul li div.line{
            width: 1px;
            height: 22px;
            position: absolute;
            background: #d7d7d7;
            /*right: 0;*/
            top: 26%;
        }
        .active>p{
            background: linear-gradient(to right,rgb(250,170,8),rgb(244,209,25));
            color: #ffffff;
            margin: 8px 20%;
            border-radius: 30px;
        }
        .resultContentBlock{
            width: inherit;
        }
        .coverMask{
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.6);
        }
        .popUp {
            width: 80%;
            max-width: 500px;
            position: fixed;
            height: 300px;
            background-color: #fff;
            box-shadow: 0px 0px 30px 0px rgba(0,0,0,0.5);
            /* border: 1px solid #333333; */
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            
            /* position: relative; */
        }
        .popUp-close{
            position: absolute;
            right: 10px;
            top: 10px;
            width:30px;
        }
        .popUp-close-icon{
            width: 30px;
        }
        .popUp-title{
            margin-top: 30px;
            margin-bottom: 20px;
        }
        .popUp-img{
            width: 160px;
            height: 160px;
            margin: 0 auto;
            overflow: hidden;
        }
        .popUp-text{
            margin-top: 20px;
            color: #666666;
            font-size: 16px;
        }
        #codeImg{
            width: 160px;
            height: 160px;
        }
    }
</style>

